import {api} from './api';

interface ApiResponse<T> {
    code: string;
    success: boolean;
    message: string;
    data: T;
}

export interface Role {
    roleId?: number;
    roleCode: string;
    roleName: string;
    description?: string;
    permissions?: Permission[];
    status?: string;
    createdTime?: string;
    updatedTime?: string;
    permissionIds?: number[];
    isInitialized?: boolean;
    isAdmin?: boolean;
}

interface Permission {
    permissionId: number;
    permissionCode: string;
    permissionName: string;
    permissionType: string;
    resourceType?: string;
    accessMode?: number;
    functionCode?: string;
}

/**
 * 角色权限关联（包含 accessMode）
 */
export interface RolePermission {
    permissionId: number;
    accessMode: number;  // 位掩码：1=R, 2=W, 4=E
}

export const roleService = {
    /**
     * 获取所有角色
     */
    getAllRoles: async (): Promise<Role[]> => {
        const response = await api.get<ApiResponse<Role[]>>('/api/v1/system/roles');
        return response.data.data || [];
    },

    /**
     * 获取角色详情
     */
    getRoleById: async (id: number): Promise<Role> => {
        const response = await api.get<ApiResponse<Role>>(`/api/v1/system/roles/${id}`);
        return response.data.data!;
    },

    /**
     * 创建角色
     */
    createRole: async (role: Role): Promise<Role> => {
        const response = await api.post<ApiResponse<Role>>('/api/v1/system/roles', role);
        return response.data.data!;
    },

    /**
     * 更新角色
     */
    updateRole: async (id: number, role: Partial<Role>): Promise<Role> => {
        const response = await api.put<ApiResponse<Role>>(`/api/v1/system/roles/${id}`, role);
        return response.data.data!;
    },

    /**
     * 删除角色
     */
    deleteRole: async (id: number): Promise<void> => {
        await api.delete(`/api/v1/system/roles/${id}`);
    },

    /**
     * 为角色分配权限（带accessMode）
     */
    assignPermissions: async (id: number, permissions: RolePermission[]): Promise<Role> => {
        const response = await api.put<ApiResponse<Role>>(`/api/v1/system/roles/${id}/permissions`, permissions);
        return response.data.data!;
    },

    /**
     * 获取角色所拥有的权限（含accessMode）
     */
    getRolePermissions: async (id: number): Promise<RolePermission[]> => {
        const response = await api.get<ApiResponse<RolePermission[]>>(`/api/v1/system/roles/${id}/permissions`);
        return response.data.data || [];
    },
};